import React, { useState } from 'react';
import {
  AppBar,
  Toolbar,
  Typography,
  Button,
  Box,
  IconButton,
  Drawer,
  List,
  ListItem,
  ListItemText,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import { Link as RouterLink, useLocation } from 'react-router-dom';

const Navbar = () => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const theme = useTheme();
  const location = useLocation();
  const isMobile = useMediaQuery(theme.breakpoints.down('lg'));

  const leftMenuItems = [
    { label: 'Corps', href: '#about' },
    { label: 'Vorteile', href: '#membership' },
    { label: 'Verbindungen', href: '#verbindung' },
  ];

  const rightMenuItems = [
    { label: 'Veranstaltungen', href: '#veranstaltungen' },
    { label: 'Haus', href: '#haus' },
    { label: 'Kontakt', href: '#contact' },
  ];

  const allMenuItems = [...leftMenuItems, ...rightMenuItems];

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const scrollToSection = (href) => {
    // Wenn wir nicht auf der Startseite sind, erst dorthin navigieren
    if (location.pathname !== '/') {
      // Navigiere zur Startseite und scrolle dann zum Abschnitt
      window.location.href = '/' + href;
      return;
    }
    
    if (href === '#home') {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } else {
      const element = document.querySelector(href);
      if (element) {
        // Berechne die Position mit einem Offset für bessere Sichtbarkeit
        const elementPosition = element.getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.pageYOffset - 100; // 100px Offset von oben
        
        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth'
        });
      }
    }
    
    // Mobile Drawer schließen falls offen
    if (isMobile) {
      setMobileOpen(false);
    }
  };

  const drawer = (
    <Box sx={{ width: 250, bgcolor: 'white' }}>
      <List>
        {allMenuItems.map((item) => (
          <ListItem 
            button 
            key={item.label} 
            onClick={() => scrollToSection(item.href)}
          >
            <ListItemText 
              primary={item.label} 
              sx={{ color: '#000' }}
            />
          </ListItem>
        ))}
      </List>
    </Box>
  );

  return (
    <>
      <AppBar position="relative" sx={{ bgcolor: 'white', boxShadow: 0 }}>
        <Toolbar sx={{ 
          justifyContent: 'center', 
          maxWidth: '1200px', 
          width: '100%', 
          margin: '0 auto', 
          justifyContent: 'space-between',
          alignItems: { xs: 'flex-start', sm: 'flex-start', md: 'center' },
          padding: '20px 20px !important' 
          }}>
          {isMobile ? (
            <>
              <Box 
                component={RouterLink}
                to="/"
                sx={{ 
                  display: 'block',
                  textDecoration: 'none'
                }}
              >
                <Box
                  component="img"
                  src="/logo_01.svg"
                  alt="Corps Guestphalia Berlin"
                  sx={{ 
                    height: { xs: 100, sm: 120, md: 140, xl: 160 },
                    width: 'auto',
                    flexGrow: { xs: 0, sm: 0, md: 0, xl: 1 },
                    cursor: 'pointer',
                    maxWidth: '200px'
                  }}
                />
              </Box>
              <IconButton
                sx={{ color: '#000' }}
                aria-label="open drawer"
                edge="end"
                onClick={handleDrawerToggle}
              >
                <MenuIcon />
              </IconButton>
            </>
          ) : (
            <Box sx={{ 
              display: 'flex', 
              alignItems: 'center', 
              gap: 5,
              width: '100%',
              justifyContent: 'center'
            }}>
              {/* Linke Navigation */}
              <Box sx={{ display: 'flex', gap: 3 }}>
                {leftMenuItems.map((item) => (
                  <Button
                    key={item.label}
                    sx={{ 
                      color: '#000',
                      fontWeight: 300,
                      fontSize: '20px',
                      textTransform: 'none',
                      '&:hover': { 
                       color: '#3a7b3e',
                        bgcolor: 'transparent'
                      }
                    }}
                    onClick={() => scrollToSection(item.href)}
                  >
                    {item.label}
                  </Button>
                ))}
              </Box>

              {/* Logo in der Mitte */}
              <Box 
                component={RouterLink}
                to="/"
                sx={{ 
                  display: 'block',
                  textDecoration: 'none'
                }}
              >
                <Box
                  component="img"
                  src="/logo_01.svg"
                  alt="Corps Guestphalia Berlin"
                  sx={{ 
                    height: 140,
                    width: 'auto',
                    mx: 4,
                    cursor: 'pointer',
                    maxWidth: '250px',
                    minWidth: 'fit-content'
                  }}
                />
              </Box>

              {/* Rechte Navigation */}
              <Box sx={{ display: 'flex', gap: 3 }}>
                {rightMenuItems.map((item) => (
                  <Button
                    key={item.label}
                    sx={{ 
                      color: '#000',
                      fontWeight: 300,
                      fontSize: '20px',
                       textTransform: 'none',
                      '&:hover': { 
                        color: '#3a7b3e',
                        bgcolor: 'transparent'
                      }
                    }}
                    onClick={() => scrollToSection(item.href)}
                  >
                    {item.label}
                  </Button>
                ))}
              </Box>
            </Box>
          )}
        </Toolbar>
      </AppBar>

      <Drawer
        anchor="right"
        open={mobileOpen}
        onClose={handleDrawerToggle}
        ModalProps={{
          keepMounted: true,
        }}
      >
        {drawer}
      </Drawer>
    </>
  );
};

export default Navbar;